import { withInstall } from '@ll-plus/utils'

import Select from './src/select.vue'
import SelectOption from './src/select-option.vue'
import SelectOptGroup from './src/select-opt-group.vue'

export const LlSelect = withInstall(Select)
export const LlSelectOption = withInstall(SelectOption)
export const LlSelectOptGroup = withInstall(SelectOptGroup)
// export default LlSelect
export * from './src/select'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlSelect: typeof Select
    LlSelectOption: typeof SelectOption
    LlSelectOptGroup: typeof SelectOptGroup
  }
}
